// Compare quantities per canonical SKU, independent of row ordering and price changes.
export function checkoutSelectionKey(items) {
  if (!Array.isArray(items) || !items.length) return null;
  const quantities = new Map();
  for (const item of items) {
    const id = Number(item.selectedVariantId ?? item.variantId), quantity = Number(item.quantity);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) return null;
    const total = (quantities.get(id) || 0) + quantity;
    if (!Number.isSafeInteger(total)) return null;
    quantities.set(id, total);
  }
  return JSON.stringify([...quantities].sort((a, b) => a[0] - b[0]));
}
export function isDifferentCartCheckout(source, pending, order, selectedItems) {
  if (source !== 'cart' || !pending?.orderId || String(order?.id) !== String(pending.orderId)) return false;
  if (!['CREATED', 'PAID', 'CANCELLED'].includes(order.status)) return false;
  const selected = checkoutSelectionKey(selectedItems), saved = checkoutSelectionKey(order.items);
  return Boolean(selected && saved && selected !== saved);
}
